












import Vue from "vue";
import { trackLanguageChoice } from "../../../helpers/XAPITracking";
import { getExtendedLanguageInfo } from "../../../helpers/getExtendedLanguageInfo";
import configRaw from "../../../../config.json";
import constructLaunchURL from "../../../helpers/constructLaunchURL";
import { storeLanguageChoice } from "../../../helpers/languageChoice";
import { LanguageSelectorConfig } from "@/interfaces";
import { isoLanguageCodes } from "@/store/Languages";
import { PropType } from "vue";

const config: LanguageSelectorConfig = configRaw as LanguageSelectorConfig;

export default Vue.extend({
  name: "LanguageLink",
  props: {
    path: String,
    code: String as PropType<isoLanguageCodes>,
    exonym: String,
    endonym: String,
    dir: String as PropType<"ltr" | "rtl">,
    isDisabled: Boolean
  },
  computed: {
    href: function(): string {
      return constructLaunchURL(this.path);
    }
  },
  methods: {
    onLanguagePressed: function(event: Event) {
      storeLanguageChoice(this.path);

      // Send chosen language to LRS
      if (config.trackingMethod === "xAPI") {
        const chosenLanguage = getExtendedLanguageInfo(this.code);
        if (chosenLanguage) {
          // Wait for the statement to be sent to the LRS before navigation
          event.preventDefault();
          trackLanguageChoice(chosenLanguage).finally(() => {
            window.location.href = this.href;
          });
        }
      }
    }
  }
});
